import React from "react";
import { Link } from "react-scroll";
import styles from "./UsageFlow.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { IoMdArrowDropright } from "react-icons/io";
import { IoMdArrowDropdown } from "react-icons/io";
import usageCloud from "../../assets/images/usageCloud.png";
import usagePaper from "../../assets/images/usagePaper.png";
import usagecart1 from "../../assets/images/usagecart1.png";
import usagecart2 from "../../assets/images/usagecart2.png";
import usagegall from "../../assets/images/usagegall.png";
import usageLaptop from "../../assets/images/usageLaptop.png";
import usageLaptop1 from "../../assets/images/usageLaptop1.png";
import usageMail from "../../assets/images/usageMail.png";
import usageimg from "../../assets/images/usageimg.png";
import usaget from "../../assets/images/usaget.png";
import { useNavigate } from "react-router-dom";
const UsageFlow = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className={`${styles.usageflow}`}>
        <div className={`container ${styles.mainSection}`}>
          <div className={styles.top_header}>ご利用の流れ</div>
          <div className={styles.link}>
            <div className={styles.box0}>
              <Link to="1" spy={true} smooth={true} offset={-90} duration={500}>
                <h6 className={styles.box_title1}>01.</h6>
                <div className={styles.spacing01}></div>
                <h6 className={styles.box_title}>
                  <IoMdArrowDropright /> 会員登録
                </h6>
                <h6 className={styles.box_title}>ログイン</h6>
                <div className={styles.box0_image}>
                  <img src={usagePaper} alt="paper" />
                </div>
              </Link>
            </div>

            <div className={styles.box1}>
              <Link to="2" spy={true} smooth={true} offset={-90} duration={500}>
                <h6 className={styles.box_title1}>02.</h6>
                <div className={styles.spacing01}></div>
                <h6 className={styles.box_title}>
                  <IoMdArrowDropright /> 撮影データ
                </h6>
                <h6 className={styles.box_title}>ダウンロード</h6>
                <div className={styles.box1_image}>
                  <img src={usageCloud} alt="paper" />
                </div>
              </Link>
            </div>
            <div className={styles.box2}>
              <Link to="3" spy={true} smooth={true} offset={-90} duration={500}>
                <h6 className={styles.box_title1}>03.</h6>
                <div className={styles.spacing01}></div>
                <h6 className={styles.box_title}>
                  <IoMdArrowDropright /> アイテム購入
                </h6>
                <h6 className={styles.box_title}>会計</h6>
                <div className={styles.box0_image}>
                  <img src={usagecart1} alt="paper" />
                </div>
              </Link>
            </div>

            <div className={styles.box3}>
              <Link to="4" spy={true} smooth={true} offset={-90} duration={500}>
                <h6 className={styles.box_title1}>04.</h6>
                <div className={styles.spacing01}></div>
                <h6 className={styles.box_title}>
                  <IoMdArrowDropright /> 写真セレクト
                </h6>
                <h6 className={styles.box_title}>編集</h6>
                <div className={styles.box3_image}>
                  <img src={usagegall} alt="paper" />
                </div>
              </Link>
            </div>
            <div className={styles.box4}>
              <Link to="5" spy={true} smooth={true} offset={-90} duration={500}>
                <h6 className={styles.box_title1}>05.</h6>
                <div className={styles.spacing01}></div>
                <h6 className={styles.box_title}>
                  <IoMdArrowDropright /> デザイン
                </h6>
                <h6 className={styles.box_title}>入稿</h6>
                <div className={styles.box1_image}>
                  <img src={usageLaptop} alt="paper" />
                </div>
              </Link>
            </div>
            <div className={styles.box5}>
              <Link to="6" spy={true} smooth={true} offset={-90} duration={500}>
                <h6 className={styles.box_title1}>06.</h6>
                <div className={styles.spacing01}></div>
                <h6 className={styles.box_title}>
                  <IoMdArrowDropright /> 最終デザイン
                </h6>
                <h6 className={styles.box_title}>確認</h6>
                <h6 className={styles.box5_sub_title}>( 一部商品のみ )</h6>
                <div className={styles.box5_image}>
                  <img src={usageLaptop1} alt="paper" />
                </div>
              </Link>
            </div>
            <div className={styles.box6}>
              <Link to="7" spy={true} smooth={true} offset={-90} duration={500}>
                <h6 className={styles.box_title1}>07.</h6>
                <div className={styles.spacing01}></div>
                <h6 className={styles.box_title}>
                  <IoMdArrowDropright /> 商品の発送
                </h6>
                <div className={styles.box6_image}>
                  <img src={usagecart2} alt="paper" />
                </div>
              </Link>
            </div>
          </div>
          <div className={`d-flex ${styles.mailbox}`}>
            <div className={styles.mail1}>
              <div>
                <IoMdArrowDropdown className={styles.arrow} />
              </div>
              <div className={styles.mail1img}>
                <img src={usageMail} alt="" />
              </div>
              <h6 className={styles.mailheading}>注文確認メール</h6>
            </div>

            <div className={styles.mail2}>
              <div>
                <IoMdArrowDropdown className={styles.arrow} />
              </div>
              <div className={styles.mail1img}>
                <img src={usageMail} alt="" />
              </div>
              <h6 className={styles.mailheading}>入稿完了メール</h6>
            </div>

            <div className={styles.mail3}>
              <div>
                <IoMdArrowDropdown className={styles.arrow} />
              </div>
              <div className={styles.mail1img}>
                <img src={usageMail} alt="" />
              </div>
              <h6 className={styles.mailheading}>確認完了メール</h6>
            </div>
            <div className={styles.mail4}>
              <div>
                <IoMdArrowDropdown className={styles.arrow} />
              </div>
              <div className={styles.mail1img}>
                <img src={usageMail} alt="" />
              </div>
              <h6 className={styles.mailheading}>発送通知メール</h6>
            </div>
          </div>
        </div>
        {/* details section */}
        <div name="1" className={styles.one}>
          <h6 className={styles.one_heading}>
            <div>01. 会員登録・ログイン</div>
          </h6>
          <div className="container">
            <h6 className={styles.one_details}>
              会員登録がお済みの方はログイン後、撮影データのダウンロード・商品購入・アイテム編集が可能です。
              <br /> 初めてご利用頂く方は、はじめに会員登録をお済ませください。
            </h6>
            <h6
              onClick={() => {
                navigate("/register");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> 新規会員登録
            </h6>
            <h6
              onClick={() => {
                navigate("/login");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> ログイン
            </h6>
          </div>
        </div>
        <div name="2" className={`mt-4 ${styles.two}`}>
          <h6 className={styles.two_heading}>
            <div>02. 撮影データのダウンロード</div>
          </h6>
          <div className="container">
            <h6 className={styles.one_details}>
              ギャラリーより撮影データのダウンロードが可能です。
            </h6>
            <h6 className={`${styles.one_details} ${styles.red}`}>
              {" "}
              無料保管期限：撮影日から３ヶ月{" "}
            </h6>
            <h6 className={styles.one_details}>
              3ヶ月以降もギャラリーの保管をご希望の方は、有料（年間保管パス）にてご利用可能です。
            </h6>
            <h6
              onClick={() => {
                navigate("/gallery-front");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> ギャラリーTOP
            </h6>
            <h6
              className={styles.one_link}
              onClick={() => {
                navigate("/gallery-annual-storage");
              }}
            >
              <IoMdArrowDropright /> 年間保管パスを購入
            </h6>
            <h6 className={styles.two_details}>
              撮影時にアイテムグッズをご購入済みの方は、
              <span className={styles.two_yellow}>
                04. 写真セレクト・編集
              </span>{" "}
              へお進みください。
            </h6>
          </div>
        </div>
        <div name="3" className={` mt-5 ${styles.three}`}>
          <h6 className={styles.three_heading}>
            <div>03. アイテムの購入・会計</div>
          </h6>
          <div className="container">
            <h6 className={styles.thee_details}>
              【送料】
              <br /> 税込１万円未満は宛先１か所　￥880（税込） <br />{" "}
              税込１万円以上で宛先１か所　送料無料 <br />{" "}
              宛先２か所目からは　一律￥880（税込）が加算されます。
            </h6>
            <h6 className={styles.three_details2}>
              オンラインショップでご希望のアイテムを選択し、お会計をお済ませください。{" "}
              <br />{" "}
              ご購入完了のメールをお送り致します。商品ごとの別送も可能です。
              <br /> ＊ご注文後24時間以内はキャンセル可能です。
            </h6>
            <h6 className={styles.one_details}>
              <img className={styles.threeImg} src={usageMail} alt="" />{" "}
              注文確認メールをお送りします。{" "}
            </h6>

            <h6
              onClick={() => {
                navigate("/onlineshop");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> オンラインショップへ
            </h6>
            <h6
              onClick={() => {
                navigate("/faq");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> お支払い方法について　
            </h6>
            <h6
              onClick={() => {
                navigate("/faq");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> 納期について
            </h6>
            <h6
              onClick={() => {
                navigate("/faq");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> 配送について
            </h6>
          </div>
        </div>
        <div name="4" className={`mt-5 ${styles.four}`}>
          <h6 className={styles.four_heading}>
            <div>04. 写真セレクト・編集</div>
          </h6>
          <div className="container">
            <h6 className={styles.three_details2}>
              お支払い済みのアイテムは、写真セレクトや文字入れ編集が可能です。
              <br />
              マイページのデザインボックスに、編集可能アイテムが表示されますので、ご希望の写真をギャラリーから選択し、編集してください。
              <br />
              複数のアイテムを購入いただいた場合は、何度かに分けて編集していただくことも可能です。
              <br />
              ギャラリーのダウンロード期限が過ぎて、ギャラリー上に写真がない場合は、ご自身のデバイスから写真をアップロードして作成してください。
            </h6>

            <h6
              onClick={() => {
                navigate("/design-box");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> デザインボックスへ
            </h6>
            <h6
              onClick={() => {
                navigate("/point-photo-1");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> 写真配置のポイント　
            </h6>
            <h6
              onClick={() => {
                navigate("/faq");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> 編集についての質問
            </h6>
          </div>
        </div>
        <div name="5" className={`mt-5 ${styles.five}`}>
          <h6 className={styles.five_heading}>
            <div>05. デザイン確定・入稿</div>
          </h6>
          <div className="container">
            <h6 className={styles.three_details2}>
              写真セレクト・文字入れ編集などが完了すると入稿完了です。MyAceから入稿完了メールをお送り致します。
              <br />
              複数のアイテムグッズを購入いただいた場合は、全てのアイテムグッズの入稿をお済ませください。
              <br />
              文字入れのあるアイテムを除いて、入稿後そのまま制作過程へと進みます。
              <br />
              入稿後は編集できません。変更希望がある場合は、LINEもしくはメールにてご連絡ください。
              <br />
              LINEもしくはメールにてご連絡ください。それ以降の修正は致しかねます。
              <br />
            </h6>
            <h6 className={styles.one_details}>
              <img className={styles.threeImg} src={usageMail} alt="" />
              入稿完了メールをお送りします。
            </h6>
          </div>
        </div>
        <div name="6" className={`mt-5 ${styles.six}`}>
          <h6 className={styles.six_heading}>
            <div>
              06. 最終デザインの確認{" "}
              <span className={styles.six_subheading}>
                ( 文字入れをした商品・台紙 )
              </span>
            </div>
          </h6>
          <div className="container">
            <h6 className={styles.three_details2}>
              ご入稿頂いたデータをデザイナーが確認し、1週間以内に完成デザインを
              <span className={styles.red}>デザインボックス</span>
              に表示します。 <br />
              完成デザインに修正が必要な場合、
              <span className={styles.red}>7日以内に</span>
              ご連絡をお願いします。
              <br />
              7日以内にご連絡がない場合は、問題がなかったとみなし、そのまま制作過程へと進みます。
            </h6>
            <h6 className={styles.one_details}>
              <img className={styles.threeImg} src={usageMail} alt="" />
              完成デザイン確認のメールをお送りします。
            </h6>
            <h6
              onClick={() => {
                navigate("/design-box");
              }}
              className={styles.one_link}
            >
              <IoMdArrowDropright /> デザインボックス
            </h6>
            {/* six box content */}
            <div className={`${styles.six_content}`}>
              <h6 className={styles.content_heading}>
                (文字入れをした商品・台紙)
              </h6>
              <div className="d-flex">
                <div className="d-flex flex-column">
                  <div className={styles.siximg}>
                    <img src={usageimg} alt="" />
                  </div>
                  <h6 className={styles.imgtxt}>完成デザイン画像</h6>
                </div>
                <div className="d-flex flex-column">
                  <h6 className={styles.six_details}>
                    お客様のご希望をもとに、デザイナーが文字入れした完成デザイン画像を{" "}
                    <br /> 作成し、確認メールをお送りします。
                  </h6>
                  <h6 className={styles.six_details2}>
                    ※ 対象アイテム：木製プレート・キャンバスフォト・アルバム{" "}
                    <br /> 　
                    　　　　　　　木製デザインプレート・パーツフォト・年賀状
                  </h6>
                  <div className={styles.line}>
                    <img src={usaget} alt="" />
                  </div>
                  <h6 className={styles.six_details}>
                    完成デザイン画像をご確認ください。問題がなければ、そのまま制作します。
                    <br /> 修正希望の場合は必ず{" "}
                    <span className={styles.red}>7日間以内</span>{" "}
                    にご連絡をお願いします。
                  </h6>
                  <div className={styles.line}>
                    <img src={usaget} alt="" />
                  </div>
                  <h6 className={styles.six_details}>
                    最終デザイン確認後、制作過程へ進みます。
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div name="7" className={`mt-5 ${styles.seven}`}>
          <h6 className={styles.seven_heading}>
            <div>07. 商品の発送</div>
          </h6>
          <div className="container">
            <h6 className={styles.three_details2}>
              最終デザインが決定後、通常1ヶ月程度でのお届けとなります。
              <br />{" "}
              アルバムは製本のためお届けまでに1~２ヶ月ほどお時間を頂戴しています。
              <br />{" "}
              また、複数ご注文いただいた場合は、全ての商品をまとめて発送となりますのでご注意ください。
              <br />{" "}
              発送の際は、発送の通知番号を登録のメールアドレスにお送り致します。配送業者の指定はできませんのでご了承下さい。
            </h6>
            <h6 className={styles.one_details}>
              <img className={styles.threeImg} src={usageMail} alt="" />
              発送通知メールをお送りします。
            </h6>
            {/* <Link
              to="/faq"
              spy={true}
              smooth={true}
              offset={-400}
              duration={500}
            >
              <h6 className={styles.one_link}>
                <IoMdArrowDropright /> 送料について
              </h6>
            </Link> */}
            <h6
              className={styles.one_link}
              onClick={() => {
                navigate("/faq");
              }}
            >
              <IoMdArrowDropright /> 送料について
            </h6>

            <div className="mb-5"></div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UsageFlow;
